<template>
  <div class="container general-section">

    <h1>
      <font-awesome-icon icon="shopping-cart" />
      Ordrar
    </h1>

    <test-data-hint />

    <div v-if="loaded">
      <div class="mb-1">
        <small class="text-muted">
          Total: {{ pagination.total }}
        </small>
      </div>

      <table class="table table-orders table-hover table-striped">
        <thead>
          <tr>
            <th>
              Datum
            </th>
            <th>
              Kund
            </th>
            <th>
              Adress
            </th>
            <th>Företag</th>
            <th></th>
            <th>
              Price
            </th>
            <th>
              Elförbrukning
            </th>
          </tr>
        </thead>

        <template v-if="orders.length > 0">
          <tbody>
          <order-item
            v-for="order in orders"
            :order="order"
            :key="order.uuid"></order-item>
          </tbody>
        </template>

        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center text-muted">
              Du har för naärvarande inga ordrar
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <contents-loader text="Laddar ordrar..." v-else />

    <pagination :pagination="pagination" :next="next"></pagination>

  </div>
</template>

<script>

  import {mapState} from "vuex"
  import Pagination from "./../../Partials/Pagination"
  import OrderItem from "./Partials/OrderItem"
  import ContentsLoader from "../../Partials/Loader/Contents"
  import TestDataHint from "../../Partials/TestData"

  export default {
    name: "Orders",
    components: {TestDataHint, ContentsLoader, OrderItem, Pagination},
    computed: {
      ...mapState({
        loaded: state => state.orders.loaded,
        orders: state => state.orders.collection,
        pagination: state => state.orders.pagination,
        affiliate: state => state.auth.affiliate,
      }),
    },
    async mounted() {
      if(this.affiliate.earnings_mode !== 'order'){
        return this.$router.push({name: 'dashboard'})
      }

      await this.get()
    },
    destroyed() {
      /**
       * When instance is destroyed (aka user navigated to other page), we need to truncate orders in store,
       * so that on new page load they are extracted from scratch
       */
      this.$store.commit('orders/truncate')
    },
    methods: {
      async next() {
        await this.get(this.pagination.current_page + 1)
      },
      async get(page = 1){
        let input = {page}

        await this.$store.dispatch('orders/fetch', input)
      },
    },
    metaInfo() {
      return {
        title: 'Ordrar'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Orders/Collection.vue